import { unsafeCSS } from 'lit';
import tabbedPageFullscreenStylesText from './tabbed-page-fullscreen.css?inline';

/**
 * Thin barrel over the sibling stylesheet, the fill-height-table.styles.ts pattern: the CSS
 * lives in a real .css file so the language server, prettier and stylelint can all see it, and
 * this module only hands it to Lit.
 *
 * Composed by every tabbed page that carries an `agwa-fullscreen-block` (#373), and composed
 * BEFORE the page's own sheet so a page can still set the rhythm of its own chrome.
 */
export const tabbedPageFullscreenStyles = unsafeCSS(
  tabbedPageFullscreenStylesText
);
